// extracted by mini-css-extract-plugin
module.exports = {"_grey":"#555","ResetBtn":"ResetBtn_ResetBtn__2PcdV","Btn":"ResetBtn_Btn__icaPR","Light":"ResetBtn_Light__2LoMQ"};